export enum Statuses {
  ERROR = 'error',
  IDLE = 'idle',
  SUCCESS = 'success',
  PENDING = 'pending',
}
